export const getFilenameWithoutExtension = (file: File) => {
    const fullName = file.name;
    const lastDotIndex = fullName.lastIndexOf('.');

    if (lastDotIndex === -1) return fullName;

    return fullName.substring(0, lastDotIndex);
};
